<script>
	import Slider from './Slider.svelte';

	let value = [1, 8];

	export let name;
</script>

<main>
	<!-- <div class="preloaded-images" -->
	<img src={`https://cdn.jsdelivr.net/gh/madingthok/adaptiiv-growth@master/Frame-${value[0]}---fixture.png`} alt="background" class="live-image"/>

	<div class="slider-only">
		<div class="slider-inside">
			<Slider bind:value>
				<span style="font-size: 20px;">
						<div class="bubble">
							<!-- <div class="bubble-dot"/> -->
						</div>
				</span>
			</Slider>
			<!-- <Slider bind:value={range} range on:input={e => console.log(e.detail)}>
				<span slot="left" style="font-size: 20px;">&#128078;</span>
				<span slot="right" style="font-size: 20px;">&#128077;</span>
			</Slider> -->
		</div>

	</div>

</main>

<style>
	.image-container {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	.live-image {
		/* width: 40vw; */
		/* height: 100px; */
		width: 100%;
		-webkit-transition: background 0.2s ease-in-out;
		transition: background 0.2s ease-in-out;
	}

	.bubble-wrapper-dropdown {
		position: absolute;
		left: auto;
		top: auto;
		right: 30%;
		bottom: 20%;
	}

	.bubble {
		width: 20px;
		height: 20px;
		padding: 3px;
		border-radius: 50px;
		background-image: -webkit-gradient(linear, left top, right top, from(#0047bb), to(#0cf));
		background-image: linear-gradient(90deg, #0047bb, #0cf);
		-webkit-transition: all 300ms ease;
		transition: all 300ms ease;
	}



	.bubble-dot {
		width: 100%;
		height: 100%;
		border-style: solid;
		border-width: 4px;
		border-color: #fff;
		border-radius: 50px;
		background-color: #0047bb;
	}

	.slider-only {
		display: flex;
		justify-content: center;
		align-content: center;
		padding-left: 3em;
		padding-right: 3em;
	}

	.slider-inside {
		min-width: 20px;
		width: 100%;
		/* display: flex; */
		/* width: 300px; */
	}
	main {
		text-align: center;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>